import { useCallback, useState } from 'react';
import { MultiSelectionContextMenu } from '../Menu/MultiSelectionContextMenu';
import { useFlowView } from '../FlowContext';
import type { NodeId } from '@/designer/designer';

interface MultiSelectionContextMenuState {
  x: number | null;
  y: number | null;
  isOpen: boolean;
  selectedNodeIds: NodeId[];
}

export const useMultiSelectionContextMenu = () => {
  const flowView = useFlowView();

  const [multiSelectionContextMenu, setMultiSelectionContextMenu] = useState<MultiSelectionContextMenuState>({
    x: null,
    y: null,
    isOpen: false,
    selectedNodeIds: [],
  });

  const openMultiSelectionContextMenu = useCallback(
    (x: number, y: number) => {
      // Get selected node IDs from FlowView (only when menu opens)
      const selectedNodeIds = flowView.selectedNodes;

      if (selectedNodeIds.length === 0) {
        return;
      }

      setMultiSelectionContextMenu({
        x: x,
        y: y,
        isOpen: true,
        selectedNodeIds,
      });
    },
    [flowView],
  );

  const closeMultiSelectionContextMenu = useCallback(() => {
    setMultiSelectionContextMenu((current) => ({ ...current, isOpen: false }));
  }, []);

  const multiSelectionContextMenuComponent =
    multiSelectionContextMenu.isOpen &&
    multiSelectionContextMenu.x !== null &&
    multiSelectionContextMenu.y !== null &&
    multiSelectionContextMenu.selectedNodeIds.length > 0 ? (
      <MultiSelectionContextMenu
        key="multi-selection-context-menu"
        positionX={multiSelectionContextMenu.x}
        positionY={multiSelectionContextMenu.y}
        isOpen={multiSelectionContextMenu.isOpen}
        onClose={closeMultiSelectionContextMenu}
        selectedNodeIds={multiSelectionContextMenu.selectedNodeIds}
      />
    ) : null;

  return {
    openMultiSelectionContextMenu,
    closeMultiSelectionContextMenu,
    multiSelectionContextMenuComponent,
  };
};
